export const standartTimings = [
    {
        day: 3,
        name: 'welcome_reminder_email_1',
        template_priority: ['welcome_reminder_email_1'],
        communication_type: 'email',
    },
    {
        day: 8,
        name: 'welcome_reminder_email_2',
        template_priority: [
            'welcome_reminder_sms_1',
            'welcome_reminder_email_2',
        ],
        communication_type: 'email',
    },
    {
        day: 16,
        name: 'welcome_reminder_email_3',
        template_priority: ['welcome_reminder_email_3'],
        communication_type: 'email',
    },
    {
        day: 45,
        name: 'welcome_reminder_email_4',
        template_priority: [
            'welcome_reminder_sms_4',
            'welcome_reminder_email_3',
        ],
        communication_type: 'email',
    },
    {
        day: 3,
        name: 'welcome_reminder_phone_1',
        template_priority: ['welcome_reminder_sms_1'],
        communication_type: 'phone',
    },
    {
        day: 8,
        name: 'welcome_reminder_phone_2',
        template_priority: [
            'welcome_reminder_email_1',
            'welcome_reminder_sms_2',
        ],
        communication_type: 'phone',
    },
    {
        day: 16,
        name: 'welcome_reminder_phone_3',
        template_priority: ['welcome_reminder_sms_3'],
        communication_type: 'phone',
    },
    {
        day: 45,
        name: 'welcome_reminder_phone_4',
        template_priority: [
            'welcome_reminder_email_3',
            'welcome_reminder_sms_4',
        ],
        communication_type: 'phone',
    },
    {
        day: 3,
        name: 'welcome_reminder_email_and_phone_1',
        template_priority: ['welcome_reminder_email_1'],
        communication_type: 'email_and_phone',
    },
    {
        day: 8,
        name: 'welcome_reminder_email_and_phone_2',
        template_priority: [
            'welcome_reminder_sms_1',
            'welcome_reminder_email_2',
        ],
        communication_type: 'email_and_phone',
    },
    {
        day: 16,
        name: 'welcome_reminder_email_and_phone_3',
        template_priority: ['welcome_reminder_email_3'],
        communication_type: 'email_and_phone',
    },
    {
        day: 45,
        name: 'welcome_reminder_email_and_phone_4',
        template_priority: [
            'welcome_reminder_sms_4',
            'welcome_reminder_email_3',
        ],
        communication_type: 'email_and_phone',
    },
];
